import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {IconButton, Stack, Step, StepLabel, Typography} from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {FC, MouseEvent, useState} from 'react';
import {Controller, useFieldArray} from 'react-hook-form';
import {InputField} from '../../../../../../../ui/input-field';
import {useStepsFormContext} from '../../contexts';
import {useStepSettingsStore} from '../../store/useStepSettingsStore';
import {STYLES} from './styles';

interface SortableStepProps {
  id: string;
  index: number;
  title: string;
  onClick: () => void;
  active: boolean;
}

export const SortableStep: FC<SortableStepProps> = ({id, index, title, onClick, active}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const {getSettingsById, setCanTitleEdit} = useStepSettingsStore();
  const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id});
  const {control} = useStepsFormContext();
  const {remove} = useFieldArray({control, name: 'steps'});

  const titleEditStore = getSettingsById(id);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleShowMenu = (event: MouseEvent<HTMLButtonElement>) => {
    onClick();
    setAnchorEl(event.currentTarget);
  };

  const handleBlurTitle = () => {
    setCanTitleEdit(id, false);
  };

  const handleMenuEditClick = () => {
    setCanTitleEdit(id, true);
    handleCloseMenu();
  };

  const handleMenuDeleteClick = () => {
    remove(index);
    handleCloseMenu();
  };

  return (
    <Step ref={setNodeRef} style={style} completed={false}>
      <StepLabel>
        <Stack direction="row" alignItems="center" justifyContent="flex-end" gap={2}>
          <Stack {...attributes} {...listeners} sx={{cursor: 'grab'}} mr={-1} mb={-1.5}>
            <DragIndicatorIcon />
          </Stack>
          <Stack width="100%" sx={{cursor: 'pointer'}} onClick={onClick}>
            <Typography sx={STYLES.stepSubLabel}>Шаг {index + 1}</Typography>
            {!titleEditStore?.canTitleEdit ? (
              <Typography sx={STYLES.stepLabel}>{title}</Typography>
            ) : (
              <Controller
                name={`steps.${index}.title`}
                control={control}
                render={({field}) => <InputField {...field} onBlur={handleBlurTitle} />}
              />
            )}
          </Stack>
          <IconButton
            size="small"
            sx={{...STYLES.stepIcon, ...(active && STYLES.stepIconActive)}}
            onClick={handleShowMenu}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
            <MenuItem onClick={handleMenuEditClick}>Изменить</MenuItem>
            <MenuItem onClick={handleMenuDeleteClick}>Удалить</MenuItem>
          </Menu>
        </Stack>
      </StepLabel>
    </Step>
  );
};
